import { Vector3 } from 'three';

import type { PlayerStore } from '../store/playerStore';
import type {
  PlayerCameraControlsHandle,
  PlayerCenterOnTargetOptions,
  PlayerFollowTarget,
} from '../types';

export function centerPlayerCameraOnTarget({
  cameraControls,
  store,
  target,
  options = {},
}: {
  cameraControls: PlayerCameraControlsHandle | null | undefined;
  store: PlayerStore;
  target?: PlayerFollowTarget;
  options?: PlayerCenterOnTargetOptions;
}): boolean {
  const resolvedTarget = store.getResolvedFollowTarget(target);
  const { distance, enableTransition = true } = options;

  if (!cameraControls || !resolvedTarget) {
    return false;
  }

  const nextTarget = resolvedTarget.getWorldPosition(new Vector3());
  const currentPosition = cameraControls.getPosition(new Vector3());
  const currentTarget = cameraControls.getTarget(new Vector3());
  const cameraOffset = currentPosition.sub(currentTarget);
  const nextOffset =
    distance === undefined
      ? cameraOffset
      : cameraOffset.lengthSq() === 0
        ? new Vector3(0, 0, distance)
        : cameraOffset.normalize().multiplyScalar(distance);
  const nextPosition = nextTarget.clone().add(nextOffset);

  cameraControls.setLookAt(
    nextPosition.x,
    nextPosition.y,
    nextPosition.z,
    nextTarget.x,
    nextTarget.y,
    nextTarget.z,
    enableTransition,
  );

  return true;
}
